import { REDIRECT } from '@/imports-files/common/common';

export function handleOtherResponseCode(status_code, router) 
{
  // const client_login_url    =   REDIRECT.client.login;
  const admin_login_url     =   REDIRECT.admins.login;
  switch (status_code) {
    case 200:
      return 200;
      break;
    case 201:
      return 201;
      break;
    case 400:
      return 400;
      break;
    case 401:
      if( router.pathname.includes('/admins/dashboard/') )
      {  router.push(process.env.NEXT_PUBLIC_BASE_URL + admin_login_url) }
      else
      {
        router.push(process.env.NEXT_PUBLIC_BASE_URL)
      }
      return 401;
      break;
    case 403:
      return 403;
      break;
    case 404:
      return 404;
      break;
    case 422:
      return 422;
      break;
    case 500:
      return 500;
      break;
    default:
      return 503;
  }
}
